import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import CustomSearch from "../../../../utils/CustomSearch/CustomSearch";
import { darkTheme, lightTheme } from "../../../../theme/Theme";
import { useSelector } from "react-redux";
import { Filter, Button } from "pepsico-ds";
import {
  commonButtonStyle,
  commonTextStyle,
} from "../../../PotatoProtection/LargeScreen/Landing/potatoprotectstyle";

export default function InvitationHistoryHeader({
  setSearch,
  handleExportCsv,
  header,
  setOrganization,
  getUniqueOptions,
  setFilter,
  setSponsor,
  user,
  setAccess,
}) {
  const isDarkTheme = useSelector((state) => state.theme);
  const handleSearch = (value) => {
    setSearch(value);
  };
  const handle = (value) => {
    setFilter(value);
  };
  const handleSponsor = (value) => {
    setSponsor(value);
  };
  const handleOrganization = (value) => {
    setOrganization(value);
  };
  const isMobile = useMediaQuery("(max-width:600px)");
  const handleAccess = (value) => {
    setAccess(value);
  };
  const isMedium = useMediaQuery("(max-width:850px)");
  let filterContent;
  if (header === "Access:invitation history") {
    filterContent = (
      <>
        <Filter
          label="Status"
          isDark={isDarkTheme}
          options={[
            { id: 1, label: "SENT", value: "SENT" },
            { id: 3, label: "ACCEPTED", value: "ACCEPTED" },
          ]}
          onChange={(val) => handle(val)}
          style={{ width: isMedium ? "100%" : "auto", maxWidth: "100%" }}
        />
        <Filter
          label="Sponsor"
          options={getUniqueOptions("sponsorEmail")}
          isDark={isDarkTheme}
          onChange={(val) => handleSponsor(val)}
          style={{ width: isMedium ? "100%" : "auto", maxWidth: "100%" }}
        />
      </>
    );
  } else if (header === "Access history") {
    filterContent = (
      <>
        <Filter
          label="Access type"
          options={user?.map((item) => ({
            id: item.id,
            label: item.name,
          }))}
          data-testid="access-filter"
          isDark={isDarkTheme}
          onChange={(val) => handleAccess(val)}
          style={{ width: isMedium ? "100%" : "auto", maxWidth: "100%" }}
        />
        <Filter
          label="Organization"
          options={getUniqueOptions("organization")}
          isDark={isDarkTheme}
          onChange={(val) => handleOrganization(val)}
          style={{ width: isMedium ? "100%" : "auto", maxWidth: "100%" }}
        />
        <Filter
          label="PepsiCo Sponsor’s email"
          options={getUniqueOptions("sponsorEmail")}
          isDark={isDarkTheme}
          onChange={(val) => handleSponsor(val)}
          style={{ width: isMedium ? "100%" : "auto", maxWidth: "100%" }}
        />
      </>
    );
  } else {
    filterContent = (
      <Filter
        label="Sponsor"
        isDark={isDarkTheme}
        options={getUniqueOptions("sponsorEmail")}
        onChange={(val) => handleSponsor(val)}
        style={{ width: isMedium ? "100%" : "auto", maxWidth: "100%" }}
      />
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: isMobile ? "14px" : "",
      }}
    >
      <Box
        sx={{
          display: "flex",
          padding: "var(--Spacing-spacing-8, 8px)",
          alignItems: isMobile ? "" : "center",
          alignSelf: "stretch",
          flexDirection: isMobile ? "column" : "",
          gap: isMobile ? "12px" : "",
          justifyContent: isMobile ? "" : "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            flex: "1 0 0",
          }}
        >
          <Typography
            sx={{
              color: isDarkTheme
                ? darkTheme.textColorLayer2
                : lightTheme.textColorLayer2,
              fontFeatureSettings: "'liga' off, 'clig' off",
              fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
              fontSize: "var(--Font-Size-H5, 24px)",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "var(--Line-Height-H5, 32px)",
            }}
          >
            {header === "Access:invitation history"
              ? "Invitation history"
              : header}
          </Typography>
        </Box>
        <CustomSearch handleSearch={handleSearch} />
      </Box>
      <Box
        sx={{
          display: "flex",
          padding: "var(--Spacing-spacing-8, 8px)",
          paddingBottom: "16px",
          alignItems: "center",
          alignSelf: "stretch",
          justifyContent: isMobile ? "" : "space-between",
          flexDirection: isMedium ? "column" : "",
          gap: isMedium ? "14px" : "",
          background: isDarkTheme
            ? darkTheme.backgroundColorLayer1
            : "var(--Tokens-Background-Layer-01, #FBFCFE)",
          boxShadow: "0px -2px 0px 0px #D7E5F8 inset",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: isMedium ? "8px" : "4px",
            flexDirection: isMedium ? "column" : "row",
            width: "100%",
          }}
        >
          {filterContent}
        </Box>
        <Button
          style={{ ...commonButtonStyle, width: isMedium ? "100%" : "" }}
          onClick={handleExportCsv}
        >
          <Typography sx={commonTextStyle}>Export</Typography>
          {/* <SaveAltIcon sx={{ fill: "white" }} /> */}
        </Button>
      </Box>
    </Box>
  );
}
